/*eslint-disable*/
import { commonApi, INcheck } from '@/common/index'
import { MessageBox, Conf } from 'element-ui';

export default {
  props:['artInfo'],
  data() {
    return {
      banner: '',
      // 无领取按钮的内容
      flowTitle: '',
      flowContent: '',
      // 有领取按钮的内容
      firstTitle: '',
      firstContent: '',

      accountType: '0',
      applyAmount: '',
      // 申请平台列表
      platformList: [],
      platformKey: '',

      // 注单编号。
      betOrderNo: '',
     

      // 升级模式
      isShowUpgradeInfo: false,
      infoList: {
        levelInfo: null,
        nextLevelBetflow: null,
        totalBetflow: null,
        totalMonthAmount: null,
        totalUpAmount: null,
        totalWeekAmount: null,
        userAccount: null
      },
      // 
      isShowDiscountsDialog:'',
    }
  },
  methods: {
    offerDetail() {
      // if (this.artInfo.accountType !== '0' && this.artInfo.platformList) {
      //   this.platformList = data.platformList;
      //   this.platformKey = data.platformList[0].platformKey;
      // } else {
      //   this.platformKey = []
      // }

      // let params = {
      //   configId: this.configId,
      //   thirdType: this.artInfo.bonusType,
      // };
      // this.$api.post(this.$urls.DISCOUNTS.offerDetail, params, (resp) => {
      //   if(resp.data.code===200){
      //     let data = resp.data.data;
      //     if(this.needButton.includes(this.artInfo.bonusType)) {
      //       this.firstTitle = data.offerTitle;
      //       this.firstContent = data.content;
      //       this.banner = data.picLink;

      //       this.accountType = data.accountType;
      //       if(this.accountType!=='0' && data.platformList) {
      //         this.platformList = data.platformList;
      //         this.platformKey = data.platformList[0].platformKey;
      //       }else {
      //         this.platformKey = []
      //       }
      //     }else {
      //       this.flowTitle = data.offerTitle;
      //       this.flowContent = data.content;
      //       this.banner = data.picLink;
      //     }
      //   }else {
      //     let msg = resp.data.msg ? resp.data.msg :resp.data.message;
      //     this.$message({
      //       message: msg,
      //       type: 'warning'
      //     })
      //   }
      // }, (err) => {})
    },

    // 存款优惠-主账户
    applyMainAccountBonus() {
      this.isReady = false;
      let params = {
        platformKey: this.platformKey,
        configId: this.artInfo.configId,
        applyAmount: this.applyAmount,
        betOrderNo: this.betOrderNo
      };
      commonApi.DEPOSIT.applyBonus(params)
        .then(data => {
          this.afterApplyDepositBonus(data)
        })
        .catch(err => {
          setTimeout(() => {
            this.isReady = true;
          }, 200);
        })
    },
    // 存款优惠-非主账户
    applyPlatformBonus(url = '') {
      let check = this.checkForm();
      if (!(this.isReady && check)) return;

      this.isReady = false;
      let params = {
        platformKey: this.platformKey,
        configId: this.artInfo.configId,
        applyAmount: this.applyAmount,
        betOrderNo: this.betOrderNo
      };
      commonApi.DEPOSIT.applyBonus(params).then(data => {
        this.afterApplyDepositBonus(data,url)
      }).catch(err => {
        setTimeout(() => {
          this.isReady = true;
        }, 200);
      })
    },
    // 回馈优惠
    applyGiveBonus() {
     
      let params = {
        configId: this.artInfo.configId,
      };
      commonApi.DEPOSIT.applyBonus(params)
        .then(data => {
          this.afterApplyDepositBonus(data)
        })
        .catch(err => {
          setTimeout(() => {
            this.isReady = true;
          }, 200);
        })
    },
    // VIP优惠-非主账户
    applyVipListBonus() {

      let check = this.checkForm();
      if (!(this.isReady && check)) return;

      this.isReady = false;
      let params = {
        platformKey: this.platformKey,
        configId: this.artInfo.configId,
      };
      commonApi.DEPOSIT.vipapplyBonus(params)
        .then(data => {
          this.afterApplyDepositBonus(data)
        })
        .catch(err => {
          setTimeout(() => {
            this.isReady = true;
          }, 200);
        })
    },
    // 注单优惠
    applyBetListBonus() {
      let check = this.checkForm();
      if (!(this.isReady && check)) return;

      this.isReady = false;
      let params = {
        platformKey: this.platformKey,
        configId: this.artInfo.configId,
        applyAmount: this.applyAmount,
        betOrderNo: this.betOrderNo
      };
      commonApi.DEPOSIT.applyBonus(params)
        .then(data => {
          this.afterApplyDepositBonus(data)
        })
        .catch(err => {
          setTimeout(() => {
            this.isReady = true;
          }, 200);
        })
    },


    // 查看可领取的时时流水优惠
    realTimeAmount() {
      this.isReady = false;
      let params = {
        UUID: this.UUID
      };
      commonApi.DEPOSIT.realTimeAmount(params)
        .then(data => {
          console.log(data)
        })
        .catch(err => {
          setTimeout(() => {
            this.isReady = true;
          }, 200);
        })
    },
    // 申请时时流水优惠
    applyRealTimeAmountBonus() {
      this.isReady = false;
      let params = {
        UUID: this.UUID,
        configId: this.artInfo.configId
      };
      commonApi.DEPOSIT.applyRealTimeAmount(params)
        .then(resp => {
          setTimeout(() => {
            this.isReady = true;
          }, 200);
          if (resp.data.code === 200) {
            this.$message({
              message: resp.data.msg,
              type: 'success'
            })
          } else {
            let msg = resp.data.data ? resp.data.data : resp.data.msg;
            this.$message({
              message: msg,
              type: 'warning'
            })
          }
        })
        .catch(err => {
          setTimeout(() => {
            this.isReady = true;
          }, 200);
        })
    },
    // 投注优惠
    applyBetBonus() {
      this.isReady = false;
      let params = {
        UUID: this.UUID,
        configId: this.artInfo.configId
      };
      commonApi.DEPOSIT.applyBetBonus(params)
        .then(resp => {
          setTimeout(() => {
            this.isReady = true;
          }, 200);
          if (resp.data.code === 200) {
            this.$message({
              message: resp.data.msg,
              type: 'success'
            })
          } else {
            let msg = resp.data.data ? resp.data.data : resp.data.msg;
            this.$message({
              message: msg,
              type: 'warning'
            })
          }
        })
        .catch(err => {
          setTimeout(() => {
            this.isReady = true;
          }, 200);
        })
    },
    // 申请客制优惠
    applyPrivateCustomBonus() {
      this.isReady = false;
      let params = {
        UUID: this.UUID,
        bonusId: this.artInfo.configId
      };
      commonApi.DEPOSIT.applyPrivateCustomBonus(params)
        .then(resp => {
          setTimeout(() => {
            this.isReady = true;
          }, 200);
          if (resp.data.code === 200) {
            this.$message({
              message: resp.data.msg,
              type: 'success'
            })
          } else {
            let msg = resp.data.data ? resp.data.data : resp.data.msg;
            this.$message({
              message: msg,
              type: 'warning'
            })
          }
        })
        .catch(err => {
          setTimeout(() => {
            this.isReady = true;
          }, 200);
        })
    },
    // 申请时时流水优惠  手动审核
    applyUserAgentBonus() {
      this.isReady = false;
      let params = {
        UUID: this.UUID,
        // configId: this.artInfo.configId
      };
      commonApi.DEPOSIT.applyUserAgentBonus(params)
        .then(resp => {
          setTimeout(() => {
            this.isReady = true;
          }, 200);
          if (resp.data.code === 200) {
            this.$message({
              message: resp.data.msg,
              type: 'success'
            })
          } else {
            let msg = resp.data.data ? resp.data.data : resp.data.msg;
            this.$message({
              message: msg,
              type: 'warning'
            })
          }
        })
        .catch(err => {
          setTimeout(() => {
            this.isReady = true;
          }, 200);
        })
    },
    // 验证领取选项
    checkForm() {
      let isOK = true;
      let msg = INcheck.checkNumber(this.applyAmount);
      if (msg && this.artInfo.bonusType === '2') {
        // this.$message({
        //   message: this.$t(msg),
        //   type: 'warning'
        // });
        this.$notify.error({
          title: this.$t('notify.error'),
          message: this.$t(msg),
        });
        isOK = false
      }

      if (this.betOrderNo === '' && this.artInfo.bonusType === '9') {
        let message = this.$t('discounts.checkBisnum2')
        // this.$message({
        //   message,
        //   type: 'warning'
        // });
        this.$notify.error({
          title: this.$t('notify.error'),
          message,
        });
        isOK = false
      }

      return isOK
    },
    // 存款红利领取后
    afterApplyDepositBonus(resp,url) {
      setTimeout(() => {
        this.isReady = true;
      }, 200);
      if (resp.data.code === 200) {
        this.$message({ message: resp.data.msg,type: 'success'})
        this.dialogTableVisible = false;
        this.betDialogTableVisible = false;
      } else if (resp.data.code === 808 && this.artInfo.bonusType === '2') {
        this.$message({ message: resp.data.msg,type: 'warning'});
        this.dialogVisible = false;
         console.log(url)
        if(url) this.$router.push({ path: url })
        else this.$router.push({ path: '/mine/deposit' })

      } else {
        let msg = resp.data.msg ? resp.data.msg : resp.data.message;
        this.$message({ message: msg,type: 'warning'})
      }
    },

    // 升级查询
    selectUserUpgradeInfo() {
      let params = {
        UUID: this.UUID,
        configId: this.artInfo.configId
      }
      commonApi.DEPOSIT.selectUserUpgradeInfo(params)
        .then(data => {
          this.isShowUpgradeInfo = true;
          this.infoList = data
        })
        .catch(err => {
          this.$notify({
            title:this.$t('notify.warning'),
            message: err,
            type: "warning",
          });
        })
    },
    closeUpgradeInfo() {
      // 关闭升级模式弹框
      this.isShowUpgradeInfo = false
    },

    //升级模式
    searchUpgradeInfo() {
      if (this.isLogin) {
        this.selectUserUpgradeInfo()
      } else {
        let tips = this.$t('discounts.needLoin2')
        this.noneLogin(tips)
      }
    },

    // 未登录的情况
    noneLogin(str, isToTop = true) {
      let tips = this.$t('common.tips')
      let confirmButtonText = this.$t('common.confirmButtonText')
      let cancelButtonText = this.$t('common.cancelButtonText')
      MessageBox.confirm(str, tips, {
        confirmButtonText,
        cancelButtonText,
        type: 'warning'
      }).then(() => {
        this.dialogTableVisible = false;
        this.dialogVisible = false
        this.IS_LOGIN_FOCUS(true);
        // 判断是否需要回到顶部
        isToTop && this.TOP_VIEW()
      }).catch(() => { });
    },
    // 未登录的情况
    noneLoginAndFocus(str) {
      let tips = this.$t('common.tips')
      let confirmButtonText = this.$t('common.confirmButtonText')
      let cancelButtonText = this.$t('common.cancelButtonText')
      MessageBox.confirm(str, tips, {
        confirmButtonText,
        cancelButtonText,
        type: 'warning'
      })
        .then(() => { })
        .catch(() => { });
    },

    withdrawGames() {
      commonApi.PAY.withdrawGames()
        .then(() => { })
        .catch(() => { })
    }
  },
  mounted() {
    // this.offerDetail();
   
    if (this.artInfo.bonusType === '2' && this.isLogin) {
      this.withdrawGames()
    }
  }
}



// WEBPACK FOOTER //
// ./src/common/mixins/bonus/applyBonus.js